// extracted by mini-css-extract-plugin
export var label = "_cx-2";
export var slideContainer = "_cx-0";
export var slider = "_cx-1";